import { Flex, Spin } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { IndividualCard } from 'pages/BtlApplicationFormPage/Applicants/Individual/IndividualCard';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';

interface CaseApplicantsListProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
}

export function CaseApplicantsList({ case: caseData, isCaseLoading }: CaseApplicantsListProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  if (isCaseLoading || !caseData) {
    return <Spin size='large' />;
  }

  const individualOrder = caseData.borrower.individualOrder || [];
  const individualsToSort = [...(caseData.borrower.individuals || [])];

  if (individualOrder.length === individualsToSort.length) {
    individualsToSort.sort((a, b) => individualOrder.indexOf(a.id) - individualOrder.indexOf(b.id));
  }

  const handleViewIndividual = (individualId: string) => {
    const searchParams = new URLSearchParams({
      section: CaseSidebarItemId.APPLICANTS,
      individualId,
    });
    navigate({ search: `?${searchParams.toString()}` });
  };

  return (
    <Flex gap={16} vertical>
      <h3 className='mb-0'>{formatMessage({ id: 'btlApplicationForm.APPLICANTS_INDIVIDUAL.individual.label' })}</h3>
      <Flex gap={16} wrap align='start'>
        {individualsToSort.map(individual => (
          <IndividualCard
            key={individual.id}
            individual={individual}
            applicationId={caseData.id}
            borrowerId={caseData.borrower.id}
            showRemoveAction={false}
            refetch={() => undefined}
            isEditable={false}
            onViewIndividual={handleViewIndividual}
            listVariant='oo'
          />
        ))}
      </Flex>
    </Flex>
  );
}
